import React, {useState, useEffect, memo} from "react";
import {Form, Button, Modal, Row, Col} from "react-bootstrap";
import {useForm} from "react-hook-form";
import Swal from "sweetalert2";
import axios from 'axios';

function UserForm({change, setChange, show, setShow}) {
    const {register, handleSubmit, reset} = useForm();
    const [users, setUsers] = useState([]);
    const [sites, setSites] = useState([]);
    const handleClose = () => {
        setShow(false);
        reset();
    };

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/user`, {page: 1, size: 1000})
            .then(function (response) {
                if (response.data.status === true) {
                    setUsers(response?.data?.data);
                } else {
                    console.log(response);
                }
            });

        axios.get(`${process.env.REACT_APP_API_URL}/site`, {page: 1, size: 1000})
            .then(function (response) {
                if (response.data.status === true) {
                    setSites(response?.data?.data);
                } else {
                    console.log(response);
                }
            });


    }, [reset]);

    const onSubmit = async (data) => {
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/content/create`, data)
                .then(function (response) {
                    if (response.data.status === true) {
                        setChange(change + 1);
                        Swal.fire({
                            text: "İşlem başarıyla tamamlandı.",
                            icon: "success",
                            confirmButtonText: "Tamam",
                        });
                        handleClose();
                    } else {
                        console.log(response);
                        Swal.fire({
                            text: response.data.message,
                            icon: "error",
                            confirmButtonText: "Tamam",
                        });
                    }

                });
        } catch (e) {
            console.log(e);
        }
    }
    return (
        <>
            <Modal show={show} size="small" onHide={handleClose} animation={false}>
                <Form className="d-flex flex-column h-100" onSubmit={handleSubmit(onSubmit)} method="POST">
                    <Modal.Header closeButton>
                        <Modal.Title
                            className="fs-5">Başlık Ekle</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <Form.Group className="mb-3">
                            <Form.Label className="required">Başlık</Form.Label>
                            <div className="d-flex">
                                <Form.Control type="text" maxLength={50} {...register("contentTitle")} required/>
                            </div>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Site</Form.Label>
                            <Form.Select {...register("contentSiteId")}>
                                <option value="">Seçiniz</option>
                                {
                                    sites != null ?
                                        sites.map(item => (
                                            <option key={item.siteId} value={item.siteId}>{item.siteName}</option>
                                        ))
                                        : null
                                }
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Editör</Form.Label>
                            <Form.Select {...register("contentEditorId")}>
                                <option value="-1">Seçiniz</option>
                                {
                                    users != null ?
                                        users.map(item => (
                                            <option key={item.userId} value={item.userId}>{item.userName}</option>
                                        ))
                                        : null
                                }

                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Görünürlük</Form.Label>
                            <Form.Select {...register("contentStatus")} required>
                                <option value="0">Evet</option>
                                <option value="4">Hayır</option>
                            </Form.Select>
                        </Form.Group>

                        <Row>
                            <Col xs={12} md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="required">Fiyat (TL)</Form.Label>
                                    <Form.Control type="number" maxLength={50} min={0} {...register("contentPrice")}
                                                  />
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="required">Kelime Sayısı</Form.Label>
                                    <Form.Control type="number" maxLength={50} min={0}
                                                  {...register("contentWordCount")}/>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Form.Group className="mb-3">
                            <Form.Label>İçerik Hakkında</Form.Label>
                            <Form.Control as="textarea" maxLength={200} {...register("contentTerms")}/>

                        </Form.Group>


                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Vazgeç
                        </Button>
                        <Button type="submit" variant="primary">
                            Kaydet
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    )
}

export default memo(UserForm);
